export const GET_DONATIONS = "GET_DONATIONS";
export const FILTER_DONATIONS = "FILTER_DONATIONS";
export const ADD_DONATION = "ADD_DONATION";
export const EDIT_DONATION = "EDIT_DONATION";
export const GET_DONATION = "GET_DONATION";
export const RESET_DONATION = "RESET_DONATION";
export const DONATIONS_ERROR = "DONATIONS_ERROR";
